(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["info-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

// ACCORDIONS
    const accordions = document.querySelectorAll(".info-accordion");

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", function() {
        const openAccordion = document.querySelector(`.info-accordion.accordion-open`);

        if (! openAccordion) {
          accordion.classList.add("accordion-open");
          return;
        }

        if (openAccordion === accordion) {
          accordion.classList.remove("accordion-open");
          return;
        }

        openAccordion.classList.remove("accordion-open");
        accordion.classList.add("accordion-open");
      });
    });
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelector(".cart-drawer .checkoutButton").addEventListener("click", function() {
    if (typeof fbq === "function") {
      fbq("trackSingle", "1389826988307183", "AddToCart", {
        currency: "EUR",
        value: Number(price),
        content_ids: [id],
        content_type: "product",
        content_name: title,
        number_of_items: 1
      });
      fbq("trackSingle", "565756356291762", "AddToCart", {
        currency: "EUR",
        value: Number(price),
        content_ids: [id],
        content_type: "product",
        content_name: title,
        number_of_items: 1
      });
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

// SWIPER FOR IMAGE GALLERY
    new Swiper(".mySwiper", {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reusable-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const accordionGroups = document.querySelectorAll(".reusable-accordion");

    accordionGroups.forEach((group) => {
      const accordions = group.querySelectorAll(".info-accordion");

      accordions.forEach((accordion) => {
        accordion.addEventListener("click", function() {
          const openAccordion = group.querySelector(".info-accordion.accordion-open");

          if (! openAccordion) {
            accordion.classList.add("accordion-open");
            return;
          }

          if (openAccordion === accordion) {
            accordion.classList.remove("accordion-open");
            return;
          }

          openAccordion.classList.remove("accordion-open");
          accordion.classList.add("accordion-open");
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upselling-full-treatment"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.addToCartMultiple').forEach(button => {
    button.addEventListener('click', async () => {
      const mainId = button.dataset.mainVariantId;
      const extraId = button.dataset.extraVariantId;
      const extraSellingPlan = button.dataset.extraSellingPlanId;
      const el = document.getElementById('my-section');
      const sellingPlanId = button.dataset.sellingPlanId;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              items: [
                {
                  id: mainId,
                  quantity: 1,
                  selling_plan: sellingPlanId
                }, {
                  id: extraId,
                  quantity: 1,
                  selling_plan: extraSellingPlan
                }
              ]
            }
          )
        });

        const data = await response.json();

        if (! response.ok) {
          console.error('Cart error:', data);
          return;
        }

        window.CartDrawer.updateCartDrawer();
        const res = await fetch("/cart.js");
        const cart = await res.json();
        window.CartDrawer.updateCartItemCounts(cart.item_count);
        document.querySelector(".cart-drawer").classList.add("cart-drawer--active");

      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
